export interface GeoLocationResponse {
  issuccessful: boolean;
  latitude: string;
  longitude: string;
  message: string;
}
